var u = /* @__PURE__ */ ((r) => (r.PASSED = "passed", r.PREVIOUS = "previous", r.CURRENT = "current", r.FUTURE = "future", r))(u || {});
export {
  u as RocheUIPipelineChangesLaneState
};
